import { render } from "./IconWheelOfFortune.vue?vue&type=template&id=39aacda0&ts=true"
import script from "./IconWheelOfFortune.vue?vue&type=script&lang=ts"
export * from "./IconWheelOfFortune.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__